import { QbrPlanning } from 'legacy/lut/components/widgets/public/partner360/planning/QbrPlanning'
import { useSelector } from 'react-redux'

import MeasureController from 'core/analytics/MeasureController'
import { NextButton } from 'partner360/components/QBR/components/qbrDocumentDetails/components/nextButton/NextButton'
import {
  selectQbrCurrency,
  selectQBREntryId,
  selectQBRFYear,
  selectQbrNetNdp,
  selectRounding,
} from 'partner360/features/QBR'

import { QBRMainHighlights } from './components/mainHighlights/QBRMainHighlights'

interface IDocumentAtGlanceProps {
  widgetParams: IObjectAny
  metrics: MeasureController
}

export const DocumentAtGlance = ({ widgetParams, metrics }: IDocumentAtGlanceProps) => {
  const fYear = useSelector(selectQBRFYear)
  const currency = useSelector(selectQbrCurrency)
  const netNdp = useSelector(selectQbrNetNdp)
  const rounding = useSelector(selectRounding)
  const documentEntryId = useSelector(selectQBREntryId)

  if (documentEntryId) {
    return (
      <div>
        <QBRMainHighlights />
        <QbrPlanning
          documentId={documentEntryId}
          fYear={fYear}
          currency={currency}
          netNdp={netNdp}
          rounding={rounding}
          widgetParams={widgetParams}
          metrics={metrics}
        />
        <NextButton isIncrementStep />
      </div>
    )
  }

  return null
}
